import $ from "jquery";
import { DATA } from "./data";
import { Test } from "./test";

const test = new Test(DATA);

$(() => {
	test.init();

	$(".video__content").on("click", () => {
		const src = $("#js-youtube-video").attr("src") + "?autoplay=1";
		$("body").addClass("show-popup");
		$("#js-youtube-video").attr("src", src);
	});

	$(".overlay, .popup__close").on("click", () => {
		const src = $("#js-youtube-video")
			.attr("src")
			.replace("?autoplay=1", "");
		$("body").removeClass("show-popup");
		$("#js-youtube-video").attr("src", src);
	});

	$(window).on("keydown", (e) => {
		if ($("body").hasClass("show-popup") && e.code === "Escape") {
			const src = $("#js-youtube-video")
				.attr("src")
				.replace("?autoplay=1", "");
			$("body").removeClass("show-popup");
			$("#js-youtube-video").attr("src", src);
		}
	});

	$(".arrow").on("click", () => {
		$("html, body").animate(
			{
				scrollTop: $(".sponsor").offset().top,
			},
			500
		);
	});

	$(".test__title").on("click", () => {
		$("html, body").animate(
			{
				scrollTop: $(".test").offset().top - 100,
			},
			500
		);
	});

	let oldscrollTop = 0;

	$(window).on("scroll", () => {
		const scrollTop = $(window).scrollTop();
		const blockTop = $(".sponsor").offset().top;
		const blockHeight = $(".sponsor").height();

		const headerHeight = $(".header").height();
		const length = scrollTop - oldscrollTop;

		if (scrollTop > blockTop - blockHeight / 2) {
			$(".arrow").addClass("is-hidden");
		} else {
			$(".arrow").removeClass("is-hidden");
		}
		if (length > headerHeight) {
			$(".header").addClass("is-hidden");
		}
		if (-length > headerHeight || scrollTop < $(".intro").height() / 2) {
			$(".header").removeClass("is-hidden");
		}

		oldscrollTop = scrollTop;
	});

	$(".test__title").on("click", () => {
		$(".test").addClass("is-active");
	});

	$(".js-toggle-content").on("click", () => {
		$(".copyright__content").toggleClass("is-visible");
	});

	$(".js-dufalak-link").on("click", (e) => {
		e.preventDefault();

		$("html, body").animate(
			{
				scrollTop: $(".sponsor").offset().top,
			},
			500
		);
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js